import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ResultItem.styled';
import ChatSectionHeader from '../../atoms/ChatSectionHeader/ChatSectionHeader';
import ResultStandard from '../ResultStandard/ResultStandard';
import ResultValueTable from '../ResultValueTable/ResultValueTable';
import ResultAudioList from '../ResultAudioList/ResultAudioList';
import ResultValueOnly from '../ResultValueOnly/ResultValueOnly';
import { resultItem } from '../../../proptypes/Actions';
import ScoreKeyHit from '../../atoms/ScoreKeyHit/ScoreKeyHit';
import ResultImageList from '../ResultImageList/ResultImageList';

// value_only, standard, advanced, audio, value_table, value_table_item,
const ResultSwitcher = ({ resultItem }) => {
  switch (resultItem.inputType) {
    case 'standard':
      return <ResultStandard resultItem={resultItem} />;
    case 'value_table':
      return <ResultValueTable resultItem={resultItem} />;
    case 'advanced':
      return <ResultAudioList resultItem={resultItem} />;
    case 'multiple_image':
      return <ResultImageList resultItem={resultItem} />;
    default:
      return <ResultValueOnly resultItem={resultItem} />;
  }
};

ResultSwitcher.propTypes = {
  resultItem: resultItem,
};

const ResultItem = (props) => {
  return (
    <Styled.Wrapper className={props.className} highlighted={props.highlighted}>
      <Styled.InnerWrapper>
        <ChatSectionHeader highlighted={props.highlighted}>
          <div>{props.resultItem.title}</div>
        </ChatSectionHeader>
        <ResultSwitcher resultItem={props.resultItem} />
      </Styled.InnerWrapper>
      {props.resultItem.scoreMetadataWithCalculated && (
        <ScoreKeyHit
          scoreMetadataWithCalculated={
            props.resultItem.scoreMetadataWithCalculated
          }
          top="-0.65rem"
        />
      )}
    </Styled.Wrapper>
  );
};

ResultItem.propTypes = {
  resultItem: resultItem,
  highlighted: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCloseDisabled: PropTypes.bool,
  className: PropTypes.string,
};

export default ResultItem;
